// src/components/UserDashboard.js
import React, { useEffect, useState, useContext } from "react";
import { 
  Table, 
  Button, 
  message, 
  Typography, 
  Card, 
  Input, 
  Space, 
  Row, 
  Col,
  Divider,
  Tag,
  Tooltip,
  Popconfirm
} from "antd";
import { 
  SearchOutlined, 
  DownloadOutlined, 
  EditOutlined, 
  DeleteOutlined, 
  PlusOutlined,
  FileTextOutlined
} from "@ant-design/icons";
import axios from "axios";
import AppLayout from "./components/AdminLayout";
import { useNavigate } from 'react-router-dom';
import { LanguageContext } from "./LanguageContext";
import { Modal, Radio } from "antd";

const { Title, Text } = Typography;

const UserDashboard = () => {
  const [configs, setConfigs] = useState([]);
  const [filteredConfigs, setFilteredConfigs] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [versionModalVisible, setVersionModalVisible] = useState(false);
const [selectedVersion, setSelectedVersion] = useState("");

  const token = localStorage.getItem("authToken");
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();
  const { language, translations } = useContext(LanguageContext);

const [versionAction, setVersionAction] = useState(""); // 'new' veya 'view'
const [selectedRecord, setSelectedRecord] = useState(null);


const handleNewConfig = () => {
  setVersionAction("new");
  setVersionModalVisible(true);
  setSelectedRecord(null);
};

const handleShowFiles = (record) => {
  setVersionAction("view");
  setSelectedRecord(record);
  setVersionModalVisible(true);
};

// Versiyon seçimi sonrası yönlendirme
const handleVersionSelect = () => {
  if (!selectedVersion) {
    message.warning("Lütfen bir versiyon seçin!");
    return;
  }

  localStorage.setItem("userVersion", selectedVersion);
  setVersionModalVisible(false);

  if (versionAction === "new") {
    navigate("/admineditablejson", { 
      state: { version: selectedVersion }
    });
  } else if (versionAction === "view" && selectedRecord) {
    navigate("/adminforselfupdateeditablejson", {
      state: { 
        configString: selectedRecord.config, 
        configId: selectedRecord.id, 
        version: selectedVersion,
        configName : selectedRecord.configName
      }
    });
  }
};



useEffect(() => {
  const savedVersion = localStorage.getItem("userVersion");
  if (savedVersion) {
    setSelectedVersion(savedVersion);
  }
}, []);


  useEffect(() => {
    if (!token || !userId) {
      message.error("Yetkisiz erişim. Lütfen giriş yapın.");
      return;
    }

    setLoading(true);
    axios
      .get(
        `https://json-configrator-api.root.myoctoopidev.com/Customer/GetByIdForUser/${userId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setConfigs(res.data.data);
          setFilteredConfigs(res.data.data);
        } else {
          message.error("Config verileri alınamadı.");
        }
      })
      .catch(() => {
        message.error("API isteği başarısız.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [token, userId]);

  const downloadConfig = (configString, id) => {
    try {
      const configJson = JSON.parse(configString);
      const blob = new Blob([JSON.stringify(configJson, null, 2)], {
        type: "application/json",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${id}_config.json`;
      link.click();
      URL.revokeObjectURL(url);
      message.success("Config dosyası başarıyla indirildi!");
    } catch (error) {
      message.error("Config verisi geçersiz JSON formatında.");
    }
  };

  const handleDelete = (record) => {
    axios.delete(
      "https://json-configrator-api.root.myoctoopidev.com/Customer/Delete",
      {
        headers: { Authorization: `Bearer ${token}` },
        data: { id: record.id },
      }
    )
    .then((res) => {
      if (res.data.success) {
        message.success(translations[language].succes);
        setConfigs((prev) => prev.filter((cfg) => cfg.id !== record.id));
        setFilteredConfigs((prev) =>
          prev.filter((cfg) => cfg.id !== record.id)
        );
      } else {
        message.error("Silme işlemi başarısız.");
      }
    })
    .catch(() => {
      message.error("API isteği başarısız.");
    });
  };

  // Sütun filtre fonksiyonları
  const getColumnSearchProps = (dataIndex, placeholder) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={placeholder}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Ara
          </Button>
          <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
            Temizle
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
  });

  const getDateColumnSearchProps = (dataIndex, placeholder) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={placeholder}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Ara
          </Button>
          <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
            Temizle
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      const dateStr = new Date(record[dataIndex]).toLocaleString("tr-TR");
      return dateStr.toLowerCase().includes(value.toLowerCase());
    },
  });

  const columns = [
    {
    title: `${translations[language].kag}`,
    dataIndex: "configName",
    key: "configName",
    width: "35%",
    ...getColumnSearchProps('configName', 'Config adını ara...'),
    render: (name) => (
      <Space>
        <FileTextOutlined style={{ color: '#1890ff' }} />
        <Text strong>{name}</Text>
      </Space>
    )
  },
  {
    title: `${translations[language].ot}`,
    dataIndex: "createDate",
    key: "createDate",
    width: "25%",
    ...getDateColumnSearchProps('createDate', 'Oluşturma tarihinde ara...'),
    render: (date) => (
      <Text type="secondary">
        {new Date(date).toLocaleString("tr-TR")}
      </Text>
    ),
    sorter: (a, b) => new Date(a.createDate) - new Date(b.createDate),
    defaultSortOrder: 'descend', // Yeniden eskiye
  },
  {
    title: `${translations[language].gt}`,
    dataIndex: "updateDate",
    key: "updateDate",
    width: "25%",
    ...getDateColumnSearchProps('updateDate', 'Güncelleme tarihinde ara...'),
    render: (date) => (
      <Text type="secondary">
        {new Date(date).toLocaleString("tr-TR")}
      </Text>
    ),
    sorter: (a, b) => new Date(a.updateDate) - new Date(b.updateDate),
    defaultSortOrder: 'descend', // Yeniden eskiye
  },
    {
      title: `${translations[language].fileOperation}`,
      key: "actions",
      width: "15%",
      render: (_, record) => (
        <Space size="small">
          <Tooltip title={translations[language].kdi}>
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              size="small"
              onClick={() => downloadConfig(record.config, record.id)}
            />
          </Tooltip>
          <Tooltip title={translations[language].showFiles}>
            <Button
              icon={<EditOutlined />}
              size="small"
              onClick={() => handleShowFiles(record)}

            />
          </Tooltip>
<Tooltip title={translations[language].removeFilses}>
  <Popconfirm
    title={translations[language].deleteConfirm}
    okText={translations[language].yes}
    cancelText={translations[language].no}
    onConfirm={() => handleDelete(record)}
  >
    <Button
      type="primary"
      danger
      icon={<DeleteOutlined />}
      size="small"
    />
  </Popconfirm>
</Tooltip>

        </Space>
      ),
    },
  ];

  return (
    <AppLayout>
      <div style={{ padding: 20 }}>
        <Card
          style={{ borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.08)', border: 'none' }}
          bodyStyle={{ padding: '20px 24px' }}
        >
          <Row justify="space-between" align="middle" style={{ marginBottom: 14 }}>
            <Col>
              <Title level={4} style={{ margin: '0 0 4px', fontWeight: 700, color: '#262626' }}>
                {translations[language].kl}
              </Title>
              <Text style={{ fontSize: 13, color: '#8c8c8c' }}>
                {filteredConfigs.length} {translations[language].konfigbulundu}
              </Text>
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={handleNewConfig}
                style={{
                  borderRadius: 8,
                  fontWeight: 600,
                  background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                  border: 'none',
                  boxShadow: '0 4px 12px rgba(24,144,255,0.35)',
                }}
              >
                {translations[language].yke}
              </Button>
            </Col>
          </Row>

          <Table
            rowKey="id"
            dataSource={filteredConfigs}
            columns={columns}
            loading={loading}
            size="small"
            pagination={{
              defaultPageSize: 15,
              showSizeChanger: true,
              pageSizeOptions: ['10', '15', '25', '50'],
              showQuickJumper: true,
              showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}`,
              size: 'small',
            }}
            style={{ borderRadius: 8, overflow: 'hidden' }}
            scroll={{ x: 800 }}
          />
        </Card>
      </div>

      <Modal
        title={null}
        open={versionModalVisible}
        onOk={handleVersionSelect}
        onCancel={() => { setVersionModalVisible(false); setSelectedVersion(""); setVersionAction(""); }}
        okText={translations[language].devamet}
        cancelText={translations[language].iptalversiyonsecc}
        centered
        width={400}
        okButtonProps={{
          style: {
            background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
            border: 'none', height: 40, borderRadius: 6, fontWeight: 500,
            boxShadow: '0 2px 8px rgba(24,144,255,0.3)',
          },
        }}
        cancelButtonProps={{ style: { height: 40, borderRadius: 6 } }}
        bodyStyle={{ padding: '32px 32px 16px' }}
      >
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{
            width: 60, height: 60, borderRadius: '50%',
            background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 14px',
            boxShadow: '0 6px 20px rgba(24,144,255,0.3)',
          }}>
            <FileTextOutlined style={{ fontSize: 26, color: '#fff' }} />
          </div>
          <h3 style={{ fontSize: 17, fontWeight: 700, color: '#262626', margin: '0 0 6px' }}>
            {translations[language].versiyonusecc}
          </h3>
          <Text style={{ color: '#8c8c8c', fontSize: 13 }}>{translations[language].versiyonsec}</Text>
        </div>

        <Radio.Group onChange={(e) => setSelectedVersion(e.target.value)} value={selectedVersion} style={{ width: '100%' }}>
          <Space direction="vertical" style={{ width: '100%' }}>
            {['v2.08', 'v2.11', 'v2.12', 'v2.13'].map((v) => (
              <div
                key={v}
                onClick={() => setSelectedVersion(v)}
                style={{
                  border: `1px solid ${selectedVersion === v ? '#1890ff' : '#e8e8e8'}`,
                  borderRadius: 8, padding: '10px 16px',
                  background: selectedVersion === v ? '#e6f4ff' : '#fafafa',
                  cursor: 'pointer',
                }}
              >
                <Radio value={v}>
                  <span style={{ fontWeight: selectedVersion === v ? 600 : 400, color: selectedVersion === v ? '#1890ff' : '#262626' }}>
                    {v}
                  </span>
                </Radio>
              </div>
            ))}
          </Space>
        </Radio.Group>
      </Modal>
    </AppLayout>



  );
};

export default UserDashboard;